import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("PageHeaderWidget", {
  title: "Page Header Widget",
  attributes: {
    destination: {
      title: "Destination",
    },
    image: {
      title: "Image",
      description:
        "Image and Background image for the header. Also used a sposter for the video.",
    },
  },
  propertiesGroups: [
    {
      title: "Content",
      properties: ["headline", "subHeadline", "description", "destination"],
    },
    {
      title: "Options",
      properties: ["image", "buttonColor"],
    },
    {
      title: "Background",
      properties: ["backgroundColor", "background"],
    },
  ],
  initialContent: {
    backgroundColor: "blue",
    headline: "Lorem Ipsum",
  },

  validations: [
    [
      "description",
      (description) => {
        const plainText = description.replace(/<[^>]*>/g, "").trim();
        if (plainText.length > 220) {
          return {
            message: `The description must not exceed 220 characters. You have used ${plainText.length} characters.`,
            severity: "error",
          };
        }
        if (plainText.length > 180) {
          return {
            message: `The description must not exceed 180 characters. You have used ${plainText.length} characters.`,
            severity: "warning",
          };
        }
        return {
          message: `You have used ${plainText.length} characters.`,
          severity: "info",
        };
      },
    ],
  ],
});
